import { ConfigData } from "@configs/config-data.type";

export const sacylDXCfg: ConfigData = {
	apiUrl: 'https://api-core.sacyl-dx.seasalt-tech.net',
	title: 'Core',
	logos: {
		login: 'assets/images/logos/sacyl/logo-text-white-v2.png',
		menu: 'assets/images/logos/sacyl/logo-text-white.png',
	},
};
